import * as React from "react";
const SvgProduct = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="product_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path d="M530.474 20.838 967.85 223.32c13.992 7.036 22.118 20.561 22.118 34.61v508.517c0 16.493-10.468 29.992-26.145 35.432l-433.348 201.662a45.612 45.612 0 0 1-36.667 0L56.994 799.962c-14.553-6.486-22.681-19.985-22.681-33.515h-.296v-508.52c0-16.469 11.354-30.018 26.494-35.93L493.806 20.837c12.21-5.664 25.61-5.664 36.668 0zM367.002 164.384l363.556 169.25 145.997-67.321L512.436 97.088l-145.434 67.296zM148.314 266.313l364.122 169.225L675.88 359.06 312.054 190.084l-163.74 76.229zm-31.974 35.956v440.104L487.415 915.69V475.012L116.34 302.27zm420.523 613.42 371.66-173.316V302.269q-185.82 85.973-371.66 172.743V915.69z" />
  </svg>
);
export default SvgProduct;
